<template>
    <div>
        <div class="field mb-8" v-if="'masked' === type">
            <label class="block uppercase text-gray-700 text-xs font-bold mb-4" :for="field.name"
                   v-text="field.label"></label>
            <input type="tel"
                   class="shadow border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                   @input="$emit('input', $event.target.value)"
                   v-mask="field.mask"
                   :id="field.name"
                   :name="field.name"
                   :value="field.value"
                   :placeholder="field.placeholder"/>
            <span class="text-xs text-red-500 font-semibold leading-tight" v-if="error.has(field.name)"
                  v-text="error.get(field.name)"></span>
        </div>
        <div class="field mb-8" v-if="'text' === type">
            <label class="block uppercase text-gray-700 text-xs font-bold mb-4" :for="field.name"
                   v-text="field.label"></label>
            <input type="text"
                   class="shadow border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                   @input="$emit('input', $event.target.value)"
                   :id="field.name"
                   :name="field.name"
                   :value="field.value"
                   :placeholder="field.placeholder"/>
            <span class="text-xs text-red-500 font-semibold leading-tight" v-if="error.has(field.name)"
                  v-text="error.get(field.name)"></span>
        </div>
        <div class="field mb-8" v-if="'textarea' === type">
            <label class="block uppercase text-gray-700 text-xs font-bold mb-6" :for="field.name"
                   v-text="field.label"></label>
            <textarea
                    class="shadow border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    @input="$emit('input', $event.target.value)"
                    v-text="field.value"
                    :name="field.name"
                    :placeholder="field.placeholder"></textarea>
            <span class="text-xs text-red-500 font-semibold leading-tight" v-if="error.has(field.name)"
                  v-text="error.get(field.name)"></span>
        </div>
        <div class="field mb-8" v-if="'radio' === type">
            <div class="mb-6">
                <h3 class="inline uppercase text-gray-700 text-xs font-bold" v-text="field.label"></h3>
                <span class="ml-2 normal-case text-xs text-red-500 font-semibold leading-tight"
                      v-if="error.has(field.name)"
                      v-text="error.get(field.name)"></span>
            </div>
            <div class="radio mb-5" :key="index" v-for="(option, index) in field.options">
                <label class="text-xs uppercase flex items-center cursor-pointer" :for="getSlug(field.name + option)">
                    <input type="radio" class="mr-2"
                           :id="getSlug(field.name + option)"
                           @change="inputValue(option)"
                           :name="field.name"
                           :checked="field.value === option"/>
                    {{option}}
                </label>
            </div>
        </div>
        <div class="field mb-8" v-if="'checkbox' === type">
            <div class="mb-6">
                <h3 class="inline uppercase text-gray-700 text-xs font-bold" v-text="field.label"></h3>
                <span class="ml-2 normal-case text-xs text-red-500 font-semibold leading-tight"
                      v-if="error.has(field.name)"
                      v-text="error.get(field.name)"></span>
            </div>
            <div class="checkbox mb-5" :key="index" v-for="(option, index) in field.options">
                <label class="text-xs uppercase flex items-center cursor-pointer" :for="getSlug(option[0])">
                    <input class="mr-2"
                           type="checkbox" @change="inputValue(option[0])"
                           :checked="option[1] === true"
                           :id="getSlug(option[0])"
                           :name="field.name"/>
                    {{option[0]}}
                </label>
            </div>
        </div>
        <div class="field mb-8" v-if="'likert' === type">
            <div class="mb-6">
                <h3 class="inline uppercase text-gray-700 text-xs font-bold" v-text="field.label"></h3>
                <span class="ml-2 normal-case text-xs text-red-500 font-semibold leading-tight"
                      v-if="error.has(field.name)"
                      v-text="error.get(field.name)"></span>
            </div>
            <table class="mb-3 hidden md:block">
                <thead>
                <tr>
                    <td>&nbsp;</td>
                    <td class="text-xs uppercase font-bold text-gray-600 py-2 px-4 text-center" :key="index"
                        v-for="(option, index) in field.options" v-text="option[0]"></td>
                </tr>
                </thead>
                <tbody>

                <tr :class="{'bg-gray-400' : index % 2 === 0, 'bg-gray-300' : index % 2 === 1}" :key="index"
                    v-for="(instruction, index) in field.instructions">
                    <td class="md:w-1/4 px-4 py-3 text-xs uppercase font-bold text-gray-700"
                        v-text="instruction[0]"></td>
                    <td class="" :key="index" v-for="(option, index) in field.options">
                        <input class="block mx-auto" type="radio"
                               @change="inputValue([instruction[1],option[1]])"
                               :checked="field.value && (field.value[instruction[1]] === option[1])"
                               :name="instruction[1]"
                               :value="index"
                        />
                    </td>
                </tr>
                </tbody>
            </table>
            <div class="likerts mb-3 block md:hidden">
                <div :key="index" v-for="(instruction, index) in field.instructions">
                    <h3 class="text-sm md:text-xs uppercase font-bold text-gray-600 py-2 px-4"
                        v-text="instruction[0]"></h3>
                    <ul>
                        <li class="mb-3 bg-gray-300 px-3 py-4" :key="index" v-for="(option, index) in field.options">
                            <label class="text-sm uppercase flex items-center cursor-pointer">
                                <input type="radio" class="mr-2"
                                       @change="inputValue([instruction[1],option[1]])"
                                       :name="instruction[1]"
                                       :value="index"/>
                                <span v-text="option[0]"></span>
                            </label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    //TODO: Implementar teste para verificar se mensagem de erro está sendo mostrada

    import Vue from 'vue'
    import Error from "@/includes/Error"
    import Field from "@/includes/fields/Field"
    import slugify from 'slugify'

    export default Vue.extend({
        props: {
            field: {
                type: Field,
                required: true
            },
            error: {
                type: Error,
                default: () => new Error()
            }
        },
        data() {
            return {
                type: '',
            }
        },
        mounted() {
            this.type = this.field.getType()
        },
        methods: {
            getSlug(name) {
                return slugify(name);
            },
            inputValue(value) {
                this.field.setValue(value)
                this.$emit('input', this.field.getValue())
            }
        }
    })
</script>